// Libraries
import moment from 'moment'

// Utilities
import CreditCard from '../../utility/creditCardUtil'
import isEmpty from '../../utility/isEmpty'

export default {
  /**
   * Returns the current default payment card, including guest card.
   */
  defaultPaymentCard (state, getters, rootState) {
    if (isEmpty(state.paymentCards)) {
      return undefined
    }

    let defaultCard

    if (!isEmpty(rootState.payment.paymentCardIds)) {
      if (rootState.payment.guestCard === true) { // If using guest card, it will not be returned in state.paymentCards, so recreate the object
        defaultCard = {
          cardIds: rootState.payment.paymentCardIds,
          cardType: rootState.payment.cardType,
          cardNumber: '•••• •••• •••• ' + rootState.payment.cardNumber,
          cardholderName: rootState.payment.cardHolderName,
          expirationMonth: parseInt(rootState.payment.expirationMonth),
          expirationYear: parseInt(rootState.payment.expirationYear),
          newCard: true
        }
      } else {
        defaultCard = CreditCard.getCardFromCards(rootState.payment.paymentCardIds, state.paymentCards)
      }
    }

    if (!isEmpty(defaultCard)) {
      return defaultCard
    }

    return state.paymentCards[0]
  },

  getDefaultDisburseCard (state) {
    if (isEmpty(state.disburseCards)) {
      return undefined
    }

    return state.disburseCards[0] // Cards should already be sorted by create date (newest first)
  },

  isCardExpired (state) {
    return function (expMonth, expYear) {
      const date = moment(['20' + expYear, parseInt(expMonth || 0) - 1, 1])
      const today = moment().startOf('day').startOf('month')

      if (date.toString().toLowerCase() === 'invalid date') {
        return false
      }

      return date.isBefore(today)
    }
  },

  getCardById (state) {
    return (cardIds) => {
      if (isEmpty(state.paymentCards) || isEmpty(cardIds)) {
        return undefined
      }

      return CreditCard.getCardFromCards(cardIds, state.paymentCards)
    }
  }
}
